import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@auth/auth.service';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { HipaaCancelWarningDialogComponent } from '../dialogs/cancel-warning/hipaa-cancel-warning-dialog.component';

@Component({
  selector: 'mpp-hipaa-benefits',
  templateUrl: './hipaa-benefits.component.html',
  styleUrls: ['./hipaa-benefits.component.scss'],
  standalone: false,
})
export class HipaaBenefitsComponent {
  private contentUrl: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
  ) {
    this.contentUrl = this.route.snapshot.queryParamMap.get('contentUrl');
  }

  public onReview(): void {
    this.router.navigate(['/hipaa-consent'], {
      queryParams: { contentUrl: this.contentUrl },
    });
  }

  public onBack(): void {
    const dialogRef = this.dialog.open(HipaaCancelWarningDialogComponent, {
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(async (shouldLogout: boolean) => {
      if (shouldLogout) {
        const spinner = this.spinnerService.show();
        this.analyticsService.logLoggedOutEvent();
        await this.authService.logout();
        spinner.hide();
      }
    });
  }
}
